import { combineReducers } from "redux";

import { dashBoardDetails } from "./reducer.dashboard"
const dashBoardReducers = combineReducers({
    dashBoardDetails
})
export default dashBoardReducers;
